import { AssetCaptionType } from '.';

export const qualifiedInvestorCaption: AssetCaptionType = {
  icon: 'QualifiedClient',
  text: 'Investidor qualificado',
  iconColor: 'brand.secondary.principal',
};

export const professionalInvestorCaption: AssetCaptionType = {
  icon: 'ProfessionalInvestor',
  text: 'Investidor profissional',
  iconColor: 'brand.tertiary.principal',
};

export const taxExemptCaption: AssetCaptionType = {
  icon: 'IncomeTaxExempt',
  text: 'Isento de IR',
  iconColor: 'brand.tertiary.dark',
};

export const dailyLiquidityCaption: AssetCaptionType = {
  icon: 'Liquidity',
  text: 'Liquidez diária',
  iconColor: 'brand.primary.principal',
};

export const fgcProtectedCaption: AssetCaptionType = {
  icon: 'Fgc',
  text: 'Garantia pelo FGC',
  iconColor: 'feedback.success.default',
};

export const fundLockedCaption: AssetCaptionType = {
  icon: 'Locked',
  text: 'Fundo fechado',
  iconColor: 'brand.tertiary.light',
};

export const notVisibleToClientCaption: AssetCaptionType = {
  icon: 'EyeOff',
  text: 'Não visível para o cliente',
  iconColor: 'neutral.white',
  iconBackgroundColor: 'neutral.light',
};
